import { HttpStatusCode } from "axios";
import { alertConstants } from "../../helper/sweet-alert";
import NotificationsService from "../../apiServices/masters/notificationsService";
import { setNotification, setNotifications, setPaginationNotification } from "../../store/slices/master/notificationSlice";
import { setNotificationType } from "../../store/slices/staff/staffNotificationSlice";
import { setNotificationCount } from "../../store/slices/master/notificationCountSlice";

export function getNotification(id: number) {
  return async function (dispatch: any, getState: any) {
    let response = await NotificationsService.getNotification(id);
    if (response?.success === true) {
      dispatch(setNotification(response.data));
    } else {
      console.log("error");
    }
  };
}

export function getNotifications(configUserRole?: number, pageBlockId?: number, departmentId?: number, collegeId?: number, noOfItems?: number, notificationTypeId?: number, pageNumber?: number) {
  return async function (dispatch: any, getState: any) {
    let response = await NotificationsService.getNotifications(configUserRole, pageBlockId, departmentId, collegeId, noOfItems, notificationTypeId, pageNumber);
    if (response?.success === true) {
      if (noOfItems) {
        dispatch(setPaginationNotification(response.data))
      }
      else {
        dispatch(setNotifications(response.data));
      }
    } else {
      console.log("error");
    }
  };
}


export function createNotification(data: any, callback: Function) {
  return async function (dispatch: any, getState: any) {
    let response = await NotificationsService.createNotification(data);
    const name = data.get("title")
    if (response?.success === true) {
      callback(alertConstants.success);
    } else {
      if (response.status === HttpStatusCode.Conflict) {
        callback(alertConstants.conflict, name);
      }
      else {
        callback(alertConstants.error);
      }
    }
  };
}

export function updateNotification(data: any, id: number, callback: Function) {
  return async function (dispatch: any, getState: any) {
    let response = await NotificationsService.updateNotification(data, id);
    if (response?.success === true) {
      callback(alertConstants.success);
    } else {
      if (response.status === HttpStatusCode.Conflict) {
        callback(alertConstants.conflict);
      } else {
        callback(alertConstants.error);
      }
    }
  };
}
export function updateNotificationPriority(data: any, callback: Function) {
  return async function (dispatch: any, getState: any) {
    let response = await NotificationsService.updateNotificationPriority(data);
    if (response?.success === true) {
      callback(alertConstants.success);
    } else {
      callback(alertConstants.error);
    }
  };
}
export function deleteNotification(id: number, callback: Function) {
  return async function (dispatch: any, getState: any) {
    let response = await NotificationsService.deleteNotification(id);
    if (response === true) {
      callback(alertConstants.inactiveSuccess);
    } else {
      callback(alertConstants.inactiveFailure);
    }
  };
}


export function getNotificationType() {
  return async function (dispatch: any, getState: any) {
    let response = await NotificationsService.getNotificationType();
    if (response?.success === true) {
      dispatch(setNotificationType(response.data));
    } else {
      console.log("error");
    }
  };
}

export function updateNotificationStatus(data: any) {
  return async function (dispatch: any, getState: any) {
    let response = await NotificationsService.updateNotificationStatus(data);
    if (response?.success === true) {
      console.log("status update success");
      dispatch(getNotificationCount());
    } else {
      console.log("status update failed");
    }
  };
}

export function getNotificationCount(configUserType?: number, notificationTypeId?: number) {
  return async function (dispatch: any, getState: any) {
    let response = await NotificationsService.notificationCount(configUserType, notificationTypeId);
    if (response?.success === true) {
      dispatch(setNotificationCount(response.data));
    } else {
      console.log("error");
    }
  };
}